import React from 'react';

const COLORS = {
  forestGreen: '#0F3D2E',
  heritageGold: '#C9A14A',
  mutedText: '#746A5B',
};

export default function PageHeader({ eyebrow, title, subtitle, action }) {
  return (
    <div style={styles.header}>
      <div style={styles.titleWrap}>
        <img src="/yabatho-logo.png" alt="YaBatho" style={styles.logo} />
        <div>
          {eyebrow && <p style={styles.eyebrow}>{eyebrow}</p>}
          <h2 style={styles.title}>{title}</h2>
          {subtitle && <p style={styles.subtitle}>{subtitle}</p>}
        </div>
      </div>
      {action && <div style={styles.action}>{action}</div>}
    </div>
  );
}

const styles = {
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 20,
    marginBottom: 24,
  },
  titleWrap: {
    display: 'flex',
    alignItems: 'center',
    gap: 14,
    minWidth: 0,
  },
  logo: {
    width: 132,
    height: 52,
    objectFit: 'contain',
    flexShrink: 0,
  },
  eyebrow: {
    color: COLORS.heritageGold,
    fontSize: 12,
    fontWeight: 900,
    letterSpacing: 0.8,
    textTransform: 'uppercase',
    margin: '0 0 4px',
  },
  title: {
    color: COLORS.forestGreen,
    fontSize: 30,
    fontWeight: 900,
    margin: 0,
  },
  subtitle: {
    color: COLORS.mutedText,
    margin: '7px 0 0',
    lineHeight: 1.5,
  },
  action: {
    flexShrink: 0,
  },
};
